<template>
  <div class="e-accordions__accordion">
    <button
      @click="toggleOpen()"
      class="e-accordions__accordion-button"
      v-bind:class="{ isOpen : open }"
      :aria-expanded="open"
      aria-label="Open section"
      :aria-controls="id"
    >
      <div class="e-accordions__accordion-title">{{ title }}</div>

      <span class="e-accordions__chevron">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path d="M6 10.1652L11.2929 15.4581C11.6834 15.8486 12.3166 15.8486 12.7071 15.4581L18 10.1652" stroke="#FF6900" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </span>
    </button>
    <div
      :id="id"
      class="e-accordions__accordion-content"
      v-bind:class="{ 'e-accordions__accordion-content--open' : open }"
      :aria-hidden="!open"
    >
      <div class="e-accordions__accordion-content-wrapper u-content">
        <div v-html="expandedContent"></div>
      </div>

      <div class="e-accordions__accordion-blocks" v-if="blocks">
        <div
          v-for="(block, index) in blocks"
          :key="index"
          class="e-accordions__accordion-block"
        >
          <div class="e-accordions__accordion-block-image-wrapper">
            <img :src="block.image" alt="" class="e-accordions__accordion-block-image" />
          </div>

          <div class="e-accordions__accordion-block-content u-content">
            <h3 v-if="block.title">{{ block.title }}</h3>
            <div v-html="block.content"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: String,
    expandedContent: String,
    blockString: String,
  },
  data() {
    return {
      id: null,
      open: false,
      blocks: [],
    };
  },
  mounted() {
    this.id = this._uid;
  },
  created() {
    // convert block string to array
    if (this.blockString) {
      this.blocks = JSON.parse(this.blockString);
    }
  },
  methods: {
    toggleOpen: function () {
      this.open = !this.open;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
